import { Instance } from 'mobx-state-tree';
import SoundProSensor from './model';

export interface ISoundProSensor extends Instance<typeof SoundProSensor> {}

export default SoundProSensor;
